import { Skeleton } from "@/components/ui/skeleton";

interface LoginHistorySkeletonProps {
  rows?: number;
}

// Mirrors the login-history row in Settings: status dot, label over a
// user-agent/IP line, right-aligned timestamp on the same tinted ground.
const LABELS = ["w-40", "w-32", "w-44"];

export default function LoginHistorySkeleton({ rows = 3 }: LoginHistorySkeletonProps) {
  return (
    <div className="space-y-2" role="status" aria-label="Loading login history">
      {Array.from({ length: rows }, (_, row) => (
        <div
          key={row}
          className="flex flex-col gap-2 rounded-lg bg-dash-hover px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-3"
        >
          <div className="flex min-w-0 items-center gap-3">
            <Skeleton className="size-2 shrink-0 rounded-full" />
            <div className="min-w-0 space-y-1.5">
              <Skeleton className={`h-4 max-w-full ${LABELS[row % LABELS.length]}`} />
              <Skeleton className="h-3 w-52 max-w-full" />
            </div>
          </div>
          <Skeleton className="h-3 w-28 shrink-0" />
        </div>
      ))}
      <span className="sr-only">Loading login history…</span>
    </div>
  );
}
